import { DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { GeocodingConfig } from '~src/geocoding/requests/GeocodingConfigRequests';

import { GeocodingRecordActionCellFormatter } from '../formatters/GeocodingRecordActionCellFormatter';
import { GeocodingRecordNameCellFormatter } from '../formatters/GeocodingRecordNameCellFormatter';
import { GeocodingRecordHeaderFormatter } from './GeocodingRecordHeaderFormatter';

const ROW_HEIGHT = 30;

export const GeocodingRecordDGConstants = {
  ConfigId: 'GeocodingRecordDG_ConfigId',
  Name: 'GeocodingRecordDG_Name',
  Task: 'GeocodingRecordDG_Task',
  Frequency: 'GeocodingRecordDG_Frequency',
  Schedule: 'GeocodingRecordDG_Schedule',
  Status: 'GeocodingRecordDG_Status',
  Action: 'GeocodingRecordDG_Action',
  GeocodingConfigObj: 'GeocodingRecordDG_GeocodingConfigObj',
  HandleEdit: 'GeocodingRecordDG_HandleEdit',
  HandleDelete: 'GeocodingRecordDG_HandleDelete',
};

interface GeocodingRecordDataGridProps {
  configRecords: GeocodingConfig[];
  handleEditConfig: (geocodingConfig: GeocodingConfig) => void;
}

export class GeocodingRecordDataGrid extends React.Component<GeocodingRecordDataGridProps, {}> {
  public getGeocodingConfigRows(): DataGrid.Row[] {
    const rows: DataGrid.Row[] = [];
    this.props.configRecords.forEach((record) => {
      let row: DataGrid.Row = {
        key: 'r-' + record.id,
        data: {},
      };
      row.data[GeocodingRecordDGConstants.ConfigId] = record.id;
      row.data[GeocodingRecordDGConstants.GeocodingConfigObj] = record;
      row.data[GeocodingRecordDGConstants.Task] = 'Geocode'; // record.schedule.type;
      row.data[GeocodingRecordDGConstants.Frequency] = '-'; // record.schedule.freq;
      row.data[GeocodingRecordDGConstants.Schedule] = '-'; // record.schedule.nextRun;
      row.data[GeocodingRecordDGConstants.Status] = 'In Progress'; // record.schedule.type;
      row.data[GeocodingRecordDGConstants.HandleEdit] = this.handleEditClick;
      row.data[GeocodingRecordDGConstants.HandleDelete] = this.handleDeleteClick;
      rows.push(row);
    });
    return rows;
  }


  private buildColumn(key: string, name: string, cellFormatter?: DataGrid.CellComponent): DataGrid.Column {
    return {
      name: name,
      dataKey: key,
      headerText: name,
      growToFit: true,
      resizable: false,
      sortable: key !== GeocodingRecordDGConstants.Action,
      cellComponent: cellFormatter,
      headerComponent: GeocodingRecordHeaderFormatter
    };
  }

  private getColumns(): DataGrid.Column[] {
    const cols: DataGrid.Column[] = [
      this.buildColumn(GeocodingRecordDGConstants.Name, Messages.geocodingRecordHeaderName(), GeocodingRecordNameCellFormatter),
      this.buildColumn(GeocodingRecordDGConstants.Task, Messages.geocodingRecordHeaderType()),
      this.buildColumn(GeocodingRecordDGConstants.Frequency, Messages.geocodingRecordHeaderFrequency()),
      this.buildColumn(GeocodingRecordDGConstants.Schedule, Messages.geocodingRecordHeaderNextRun()),
      this.buildColumn(GeocodingRecordDGConstants.Status, Messages.geocodingRecordHeaderStatus()),
      this.buildColumn(GeocodingRecordDGConstants.Action, Messages.geocodingRecordHeaderAction(), GeocodingRecordActionCellFormatter),
    ];
    return cols;
  }

  private getRowStore(): DataGrid.RowStore {
    const allRows = this.getGeocodingConfigRows();
    return {
      getItems: (_: number, __: number, rowHandler: (rows: Promise<DataGrid.Row[]> | DataGrid.Row[]) => void) => {
        rowHandler(allRows);
      },
    };
  }

  private handleEditClick = (config: GeocodingConfig): void => {
    this.props.handleEditConfig(config);
  };

  private handleDeleteClick = (configId: string): void => {
  };

  public render(): JSX.Element {
    if (this.props.configRecords.length === 0) {
      return;
    }

    const dataGridProps: DataGrid.Props = {
      cols: this.getColumns(),
      rowStore: this.getRowStore(),
      showRowBanding: false,
      headerHeight: ROW_HEIGHT,
      config: { rowOuterHeight: ROW_HEIGHT },
    };

    return (
      <div className='geocodingConfigRecordsDatagrid'>
        <DataGrid {...dataGridProps} />
      </div>
    );
  }
}
